import Actions from './action';

export const initState = {
	isFeeLoading: false,
	feeData: [],
	getTosLoading: false,
	tosData: ''
};

const feeReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.GET_FEE_DATA_START: {
			return {
				...state,
				isFeeLoading: true,
			};
		}
		case Actions.types.GET_FEE_DATA_SUCCESS: {
			return {
				...state,
				isFeeLoading: false,
				feeData: action.res.data,
			};
		}
		case Actions.types.GET_FEE_DATA_ERROR: {
			return {
				...state,
				isFeeLoading: false,
			};
		}
		case Actions.types.GET_TOS_DATA: {
			return {
				...state,
				getTosLoading: true,
			};
		}
		case Actions.types.GET_TOS_DATA_SUCCESS: {
			return {
				...state,
				getTosLoading: false,
				tosData: action.res.data.company,
			};
		}
		case Actions.types.GET_TOS_DATA_ERROR: {
			return {
				...state,
				getTosLoading: false,
			};
		}

		default:
			return state;
	}
};

export default feeReducer;
